<template>
    <v-app>
        <div class="login">
            <div class="loginBg"></div>

            <div class="loginContent">
                <div class="con bigFont loginLayout text-xs-center">
                    <img src="../assets/images/logo.png" width="60px" class="text-xs-center"/>

                    <!--<v-btn @click=""  @click="loginAdmin()">-->
                        <!--관리자 로그인-->
                    <!--</v-btn>-->

                    <!--<p  class="text-xs-left pa-0 ma-0"><b>{{login_type_text}}</b></p>-->
                    <div class="loginBtn">
                        <v-btn @click="" class="social-login-btn naver-login-btn" @click="loginNaver()">
                            네이버 계정으로 로그인
                        </v-btn>
                        <v-btn @click="" class="social-login-btn facebook-login-btn" @click="loginFacebook()">
                            페이스북 계정으로 로그인
                        </v-btn>
                        <v-btn @click="" class="social-login-btn kakao-login-btn" @click="loginKakao()">
                            카카오톡 계정으로 로그인
                        </v-btn>
                    </div>

                    <div class="loginFooter">
                        <p class="infoTxt">
                            ©IBK System Co.,Ltd. All Rights Reserved.
                        </p>
                    </div>

                </div>
            </div>


        </div>

    </v-app>
</template>

<script>

	import * as code from '../common/code'
	import querystring from 'querystring'
	import { mapActions, mapGetters } from 'vuex'




    export default {

        name: 'Login',
        data: () => ({

        }),
        created(){


	        console.log( `Log ${process.env.NODE_ENV}  ` )
	        this.initView()
        },
        computed: {

        },
        methods: {
	        ...mapActions('user',['localLogin', 'snsLogin']),
	        ...mapGetters( 'user', [ 'getAccessToken' ] ),

	        /////////////////////////////////////////////////// FUNC /////////////////////////////////////////////////////////

	        initView(){


		        // 네이버 OAuth2로 화면 리다이렉팅되었을 때, url 주소의 query 여부 판별
		        // code값이 있는 경우, Naver Login 요청
		        if(Object.keys(this.$route.query).length !== 0 && this.$route.query.code){

			        let code = this.$route.query.code
			        let state = this.$route.query.state

                    if(state == 'naver')
                    {
	                    let req = {
		                    sns_type : state,
		                    code ,
		                    state
	                    }


                        this.reqLogin(req)
                    }


		        }
	        },
	        loginFinsh(){
		        // 로컬 로그인 후 store에 저장 된 accessToken 여부로 메인화면 전환
		        this.$router.push({name: 'Main'})

	        },
	        // 네이버로 로그인
	        loginNaver() {

		        // 로그인 페이지 요청을 위한 파라미터
		        let req = {
			        response_type: code.SNS.NAVER.RESPONSE_TYPE,
			        client_id: code.SNS.NAVER.CLIENT_ID,
			        redirect_uri: process.env.VUE_APP_NAVER_LOGIN_REDIRECT_URI,
			        isPopup: true,
			        state: code.SNS.NAVER.STATE,
		        }

		        if(process.env.NODE_ENV =='production')
                {
	                req.redirect_uri =  code.SNS.NAVER.REDIRECT_URI
                }

                window.open( `${process.env.VUE_APP_NAVER_AUTH_URL}${querystring.stringify( req )}`, '_parent' )

	        },
	        loginFacebook(){

		        // 페이스북 로그인 상태 확인
		        FB.getLoginStatus( response => {
			        FB.login( res => {
				        if( res.status === 'connected' ) {

					        let req = {
						        sns_type: code.SNS.PROVIDER_TYPE.FACEBOOK,
						        access_token: res.authResponse.accessToken

					        }

					        this.reqLogin( req )

				        }
			        } );
			        // }
		        }, true ); // 중복실행방지


	        },
	        // 카카오로 로그인
	        loginKakao() {

		        // 최초 카카오 SDK init
		        if( ! Kakao.Auth ) {
			        Kakao.init( process.env.VUE_APP_KAKAO_APP_ID);
		        }


		        // 카카오 로그인 창 호출
		        Kakao.Auth.loginForm( {
			        success: ( authObj ) => {

				        let req ={
					        sns_type : code.SNS.PROVIDER_TYPE.KAKAO,
					        access_token : authObj.access_token
				        }


				        this.reqLogin(req)

			        },
			        fail: ( err ) => {
				        console.log( `Log  err = ${JSON.stringify( err, null, 2 )}` )
			        }
		        } );


	        },

	        loginAdmin(){

		        let req ={
			        sns_type : code.SNS.PROVIDER_TYPE.FACEBOOK,
			        access_token : 'EAAeO6js3xloBAN1clU91RFq9iPCZCsneoiYWNSl4mOl650ZAI657qUcQZB00Aa0zVsrDoOUDHzH7fx8zmKYCgmK4QxmW5E1IA7lfLpvkxmVtV10Y5iH9GrYPCnhBeeKJZCC3qApI2QM2OxT8gZBuaj7paSYb3cf9GsMTc0xGKrsW3AtPWaktOIKybSXu5pE6Fv9HtHd6YlAZDZD'
		        }


		        this.reqLogin(req)

            },
	        /////////////////////////////////////////////////// REQ /////////////////////////////////////////////////////////

            reqLogin(req){


	            this.localLogin( req ).then(_=>{

		            localStorage.setItem('sns_access_token', req.access_token)
		            localStorage.setItem('sns_type', req.sns_type)

		            this.loginFinsh()



	            }).catch(e=>{

		            this.$dialog.alert(e.message)

	            })
            },

        }
    }
</script>

<style lang="scss">
    @import '../assets/styles/index';


    .loginContent{
        width:450px;
        height: 340px;
        background: #fff;
        margin:auto auto;
        position: relative;
        padding: 30px 10px;
        z-index: 2;

    }
    .loginBg{
        position: absolute;
        top:0;
        left:0;
        background: url("../assets/images/login_bg.jpg");
        background-size: cover;
        width:100%;
        height:100%;
    }
    .login{
        position: absolute;
        z-index: 1;
        width: 100%;
        display: flex;
        align-items: center;
        min-height: 100vh;
        padding: 100px 0 120px;
    }
    .login:after{
        position: absolute;
        z-index: 1;
        width: 100%;
        height: 100%;
        display: block;
        left: 0;
        top: 0;
        content: "";
        background-color: rgba(0,0,0,.7);
    }

    .con{width: 300px;margin:0 auto;}
    .loginBtn{
        margin-top:30px;
    }

    ////////////////////////footer

    .loginFooter {
        /*position: relative;*/
        position: absolute;
        bottom: 0;
        left: 0;
        padding: 10px;
        width: 100%;
        text-align: center;


        .infoTxt {
            cursor: default;
            color: #808080;
            font-size: 12px;
            text-align: center;
            position: relative;
            top:0;
            /*padding: 10px;*/
            /*background-color: red;*/
            a{  color: #b5b9bf; font-size: 14px;}
        }
    }

    //SNS로그인버튼

    .social-login-btn {
        position: relative;
        top:0;left:0;
        width: 100%;
        height: 50px;
        /*padding: 10px 0;*/
        margin-bottom: 10px;
        display: block;
        border-radius: 5px;
        /*font-size: 1.2em;*/
        font-family: 'noto', 'Roboto', sans-serif;
    }

    .naver-login-btn {
        background : url("../assets/images/naver.gif") 0px 2px no-repeat;
        background-color: #1ec800 !important;
        color:#fff !important;
        font-weight: bold;
    }
    .facebook-login-btn {
        background: url("../assets/images/facebook.gif") 0px 1px no-repeat;
        background-color: #3b66c4 !important;
        color:#fff !important;
        font-weight: bold;
    }
    .kakao-login-btn {
        background: url("../assets/images/kakaotalk.gif") 1px 2px no-repeat;
        background-color: #ffd800 !important;
        color:#000;
        font-weight: bold;
    }

</style>



